<template>
  <b-card no-body class="border-0 my-2 my-md-4 position-relative z-1">
    <b-row no-gutters class="g-2">
      <b-col cols="12" md="4" v-for="(item, index) in clustersList" :key="`news-${index}`">
        <b-card no-body class="position-relative border-0">
          <div class="position-absolute bottom-0 start-0 w-100 p-3">
            <p class="display-1 mb-0 text-center timer text-white">
              <ICountUp :delay="300" :endVal="item.count" :options="options" />
            </p>
            <p class="m-0">
              <b-button variant="primary" class="w-100 fs-5" @click="searchCluster(item.id, item.name)">
                {{ item.name }}
              </b-button>
            </p>
          </div>
          <div class="ratio ratio-16x9 -z-1">
            <b-img-lazy :src="`${SERVER_URL}${item.picture}`" class="card-img-top object-fit-cover" />
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-card>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import ICountUp from 'vue-countup-v2';
import { SERVER_URL } from '@/config/constant';
import { AppModule } from '@/store/modules/app';

@Component({
  components: {
    ICountUp,
  },
})
export default class InformationBox extends Vue {
  @Prop({ type: Array }) clustersList!: any[];

  SERVER_URL = SERVER_URL;

  options = {
    useEasing: true,
    useGrouping: true,
    separator: AppModule.language === 'en' ? ',' : '.',
    decimal: '.',
    prefix: '',
    suffix: '',
  };

  searchCluster(id: number, title: string) {
    this.$emit('search-cluster', { id, title });
  }
}
</script>
<style scoped lang="scss">
.timer.text-white {
  text-shadow: 1px 1px 9px rgba(0, 0, 0, 0.6);
}
</style>
